function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

export var CursorHelper = /*#__PURE__*/function () {
  function CursorHelper() {}

  CursorHelper.normalizePosition = function normalizePosition(map, position) {
    return map[Math.min(Math.max(0, position), map.length - 1)];
  };

  CursorHelper.calculatePosition = function calculatePosition(map, position, step) {
    if (position < 0 || map.length <= position) {
      throw new Error("position out of range [" + 0 + " .. " + (map.length - 1) + "], actual value: " + position);
    }

    var raw = CursorHelper.toRawPosition(map, position);
    return CursorHelper.toFormattedPosition(map, raw + step);
  };

  CursorHelper.extendSelection = function extendSelection(map, selection, step) {
    selection = CursorHelper.normalizeSelection(map, selection);
    selection = selection.direction === 'backward' ? {
      start: CursorHelper.calculatePosition(map, selection.start, step),
      end: selection.end,
      direction: 'backward'
    } : {
      start: selection.start,
      end: CursorHelper.calculatePosition(map, selection.end, step),
      direction: 'forward'
    };
    return CursorHelper.normalizeSelection(map, selection);
  };

  CursorHelper.normalizeSelection = function normalizeSelection(map, selection) {
    var start = CursorHelper.normalizePosition(map, selection.start);
    var end = CursorHelper.normalizePosition(map, selection.end);

    if (start === end) {
      return {
        start: start,
        end: end,
        direction: 'none'
      };
    }

    if (start < end) {
      return {
        start: start,
        end: end,
        direction: selection.direction === 'backward' ? 'backward' : 'forward'
      };
    }

    return {
      start: end,
      end: start,
      direction: selection.direction === 'backward' ? 'forward' : 'backward'
    };
  };

  CursorHelper.toRawPosition = function toRawPosition(map, formattedPosition) {
    var count = Math.min(Math.max(0, formattedPosition), map.length - 1);
    return new Set(map.slice(0, count + 1)).size - 1;
  };

  CursorHelper.toFormattedPosition = function toFormattedPosition(map, rawPosition) {
    var count = Math.max(0, rawPosition) + 1;
    var unique = new Set();

    for (var _iterator = _createForOfIteratorHelperLoose(map), _step; !(_step = _iterator()).done;) {
      var position = _step.value;
      unique.add(position);

      if (unique.size === count) {
        return position;
      }
    }

    return map[map.length - 1];
  };

  return CursorHelper;
}();